import { ROUTES } from "./common";

export const MANAGE_DISTRIBUTION_ROUTES = {
  WITHDRAWAL_REQUEST: `${ROUTES.DISTRIBUTION}/withdrawal-request`,
  LOAN_REQUEST: `${ROUTES.DISTRIBUTION}/loan-request`,
  LOAN_SUMMARY: `${ROUTES.DISTRIBUTION}/loan-summary`,
  WITHDRAWAL_SUMMARY: `${ROUTES.DISTRIBUTION}/withdrawal-summary`,
  WITHDRAWAL_ALLOCATION: `${ROUTES.DISTRIBUTION}/withdrawal-allocation`,
};

export const MANAGE_TRANSFER_ROUTES = {
  TRANSFER_REQUEST: `${ROUTES.DISTRIBUTION}/transfer-request`,
  TRANSFER_SUMMARY: `${ROUTES.DISTRIBUTION}/transfer-summary`,
  REBALANCE_REQUEST: `${ROUTES.DISTRIBUTION}/rebalance-request`,
  REBALANCE_SUMMARY: `${ROUTES.DISTRIBUTION}/rebalance-summary`,
};

export const manageDistributionFormNames = {
  WITHDRAWAL_REQUEST: "withdrawal-request",
  TRANSFER_REQUEST: "transfer-request",
  REBALANCE_REQUEST: "rebalance-request",
  LOAN_REQUEST: "loan-request",
  LOAN_REFINANCE_REQUEST: "loan_refinance_request",
  LOAN_SUSPENSION_REQUEST: "loan_suspension_request",
};

export const distributionFormFields = {
  [manageDistributionFormNames.WITHDRAWAL_REQUEST]: {
    withdrawalRequest: "withdrawalRequest",
    withdrawalType: "withdrawalType",
    modeOfPayment: "modeOfPayment",
    withdrawalName: "withdrawalName",
    withdrawalId: "withdrawalId",
    userId: "userId",
    withdrawalTransactions: "withdrawalTransactions",
    withdrawEntireAmount: "withdrawEntireAmount",
    grossOrEntireAmount: "grossOrEntireAmount",
    netAmountRequested: "netAmountRequested",
    withdrawalStatus: "withdrawalStatus",
    requestDate: "requestDate",
    periodicPaymentType: "periodicPaymentType",
    distributionDetails: "distributionDetails",
    distributionMode: "distributionMode",
    choosePaymentMethod: "choosePaymentMethod",
    payeeType: "payeeType",
    paymentMethod: "paymentMethod",
    benificiary: "benificiary",
    beneficiaryName: "beneficiaryName",
    beneficiaryId: "beneficiaryId",
    sponsorApprovalRequired: "sponsorApprovalRequired",
    numberOfWithdrawalAllowed: "NumberOfWithdrawalAllowed",
    code: "code",
    spousalConsentFileUpload: "spousalConsentFileUpload",
    adoptionOrBirthCertificateFileUpload:
      "adoptionOrBirthCertificateFileUpload",
    promissoryNoteFileUpload: "promissoryNoteFileUpload",
    nextRepaymentDate: "nextRepaymentDate",
    interestRatePerAnnum: "interestRatePerAnnum",
    withdrawalAmountPerFrequency: "withdrawalAmountPerFrequency",
    typeOfExpectancy: "typeOfExpectancy",
    netPeriodicPaymentAmount: "netPeriodicPaymentAmount",
    numberOfInstallments: "numberOfInstallments",
    sortOrder: "sortOrder",
    codeForRoleOver: "codeForRoleOver",
    bankName: "bankName",
    accountHolderName: "accountHolderName",
    accountType: "accountType",
    accountNumber: "accountNumber",
    creditUnion: "creditUnion",
    checkPayableTo: "checkPayableTo",
    addressId: "addressId",
    address1: "address1",
    address2: "address2",
    address3: "address3",
    zipCode: "zipCode",
    mobileNumber: "mobileNumber",
    emailId: "emailId",
    city: "city",
    stateId: "stateId",
    state: "state",
    country: "country",
    countryId: "countryId",
    requestedAmount: "requestedAmount",
    grossAmount: "grossAmount",
    feeAndTaxSplit: "feeAndTaxSplit",
    typeOfAddressOrBankDetails: "typeOfAddressOrBankDetails",
    checkFee: "checkFee",
    eftFee: "eftFee",
    stateTax: "stateTax",
    federalTax: "federalTax",
    planId: "planId",
    trusteeName: "trusteeName",
    planName: "planName",
    iraNumber: "iraNumber",
    iraPlanName: "iraPlanName",
    rollOverFee: "rollOverFee",
    recurringFee: "recurringFee",
    alternativeEmailAddress: "alternativeEmailAddress",
    alternativePhoneNumber: "alternativePhoneNumber",
    extensionNumber: "extensionNumber",
    phoneNumber: "phoneNumber",
    bankId: "bankId",
    grossWithdrawalAmount: "grossWithdrawalAmount",
    withdrawalFee: "withdrawalFee",
    nameOfTheFinancialInstitution: "nameOfTheFinancialInstitution",
    accountHolderName: "accountHolderName",
    typeOfAccount: "typeOfAccount",
    checkingSavingsAccountNumber: "checkingSavingsAccountNumber",
    abaRoutingNumberforBankOfCreditUnion:
      "abaRoutingNumberforBankOfCreditUnion",
    waiveOffLimitApplicable: "waiveOffLimitApplicable",
    waiveOffLimit: "waiveOffLimit",
    waiveOffLimitReason: "waiveOffLimitReason",
    earlyWithdrawalPenalty: "earlyWithdrawalPenalty",
    iraNumber: "iraNumber",
    nameOfTheFinancialInstitution: "nameOfTheFinancialInstitution",
    trusteeName: "trusteeName",
    foreignCountry: "foreignCountry",
    foreignState: "foreignState",
    foreignZipCode: "foreignZipCode",
    sourceHierarchyList: "sourceHierarchyList",
    sourceAllocationCalculationMethod: "sourceAllocationCalculationMethod",
    hierarchyCalculationMethod: "hierarchyCalculationMethod",
    sourceHierarchyDetails: "sourceHierarchyDetails",
    allocatedSourceWithdrawal: "allocatedSourceWithdrawal",
    hierarchyNumber: "hierarchyNumber",
    investmentHierarchies: "investmentHierarchies",
    investmentId: "investmentId",
    sourceId: "sourceId",
    withdrawalTransactions: "withdrawalTransactions",
    beneficiaryId: "beneficiaryId",
    frequency: "frequency",
    dateOfAnnuityPayments: "dateOfAnnuityPayments",
    address: "address",
    sourceAllocationCalculationMethod: "sourceAllocationCalculationMethod",
    customizeAllocationCalculationMethod:
      "customizeAllocationCalculationMethod",
    taxesAndFees: "taxesAndFees",
    signedThroughDocusign: "signedThroughDocusign",
  },
  [manageDistributionFormNames.LOAN_REQUEST]: {
    // loadSettingId:"loanSettingId",
    planId: "planId",
    planName: "planName",
    loanType: "loanType",
    loanReason: "loanReason",
    withdrawEntire: "withdrawEntire",
    requestedAmount: "requestedAmount",
    repaymentFrequency: "repaymentFrequency",
    periodicPayment: "periodicPayment",
    firstRepaymentDate: "firstRepaymentDate",
    payrollFrequency: "payrollFrequency",
    tenureYears: "tenureYears",
    tenureMonths: "tenureMonths",
    address1: "address1",
    address2: "address2",
    address3: "address3",
    paymentOption: "paymentOption",
    paymentMethod: "paymentMethod",
    loanFeeAmount: "loanFeeAmount",
    eftFees: "eftFees",
    chequeFees: "chequeFees",
    bankName: "bankName",
    accountHolderName: "accountHolderName",
    accountType: "accountType",
    accountNumber: "accountNumber",
    creditUnion: "creditUnion",
    address: "address",
    zipCode: "zipCode",
    mobileNumber: "mobileNumber",
    emailId: "emailId",
    city: "city",
    stateId: "stateId",
    state: "state",
    country: "country",
    countryId: "countryId",
    overnightDeliveryFees: "overnightDeliveryFees",
    additionalBankInformation: "additionalBankInformation",
    promissoryNoteDocURL: "promissoryNoteDocURL",
    spousalConsentDocURL: "spousalConsentDocURL",
    loanDocument: "loanDocument",
    loanStatus: "loanStatus",
    isDraft: "isDraft",
    interestRate: "interestRate",
    address: "address",
    bank: "bank",
    foreignCountry: "foreignCountry",
    foreignState: "foreignState",
    foreignZipCode: "foreignZipCode",
    countryCode: "countryCode",
    checkPayableTo: "checkPayableTo",
    repaymentMethod: "repaymentMethod",
    loanTypeDescription: "loanTypeDescription",
    signedThroughDocusign: "signedThroughDocusign",
  },
  [manageDistributionFormNames.LOAN_REFINANCE_REQUEST]: {
    loanAmount: "loanAmount",
    interestRate: "interestRate",
    tenureYears: "tenureYears",
    tenureMonths: "tenureMonths",
    repaymentMethod: "repaymentMethod",
    repaymentFrequency: "repaymentFrequency",
    periodicPaymentAmount: "periodicPaymentAmount",
    transactionFees: "transactionFees",
  },
  [manageDistributionFormNames.LOAN_SUSPENSION_REQUEST]: {
    reasonForSuspension: "reasonForSuspension",
    reasonForSuspensionOthersReason: "reasonForSuspensionOthersReason",
    suspensionInterestRate: "suspensionInterestRate",
    suspensionStartDate: "suspensionStartDate",
    suspensionEndDate: "suspensionEndDate",
  },
  [manageDistributionFormNames.TRANSFER_REQUEST]: {
    planId: "planId",
    transferSourceDetails: "transferSourceDetails",
    transferInvestmentDetails: "transferInvestmentDetails",
    investmentName: "investmentName",
    percentage: "percentage",
    amount: "amount",
  },
  [manageDistributionFormNames.REBALANCE_REQUEST]: {
    planId: "planId",
  },
};
